// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"b2fa4e81","156":"96c165c5","878":"0bd7df6a"}[chunkId] + ".chunk.css";
};